import React from "react";

export const AvatarGroup: React.FC<unknown> = (props) => {
  const { children } = props;

  return <div className={"avatar-group -space-x-6"}>{children}</div>;
};
